import { ReportCategory } from "pages";
import adminRouteMap from "routeControl/adminRouteMap";

export default function route() {
  return [
    {
      path: adminRouteMap.REPORT_CATEGORY.path,
      name: "Report Category",
      key: adminRouteMap.REPORT_CATEGORY.path,
      private: true,
      belongsToSidebar: true,
      icon: adminRouteMap.REPORT_CATEGORY.icon,
      element: <ReportCategory />,
    },
  ];
}
